import { Component } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { DragLayer } from 'react-dnd';
import ResizableDragHandle from './ResizableDragHandle';
import { RESIZABLE_REPLY_EDITOR_ID } from './ResizableThreadViewWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const getDragLayerStyles = () => {
  return {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 1000,
    pointerEvents: 'none'
  };
};
export const getPreviewWrapperStyles = ({
  startOffset,
  currentOffset,
  maxEditorHeight,
  minEditorHeight
}) => {
  if (!currentOffset || !startOffset) {
    // these become undefined on drop
    //  but the preview still renders for one more cycle
    return {
      display: 'none'
    };
  }
  const windowHeight = window.innerHeight;
  const NavBarHeight = 60;
  const ThreadToolBarHeight = 60;
  const threadViewHeight = windowHeight - NavBarHeight - ThreadToolBarHeight;
  // 60px is both the height of navbar and the height of threadToolBar, to fix this otherwise would require a lot of refs and magic and fixed positioning,
  //  so opting for this less elegant approach.

  const newHeight = Math.min(maxEditorHeight, Math.max(minEditorHeight, windowHeight - currentOffset.y)) - 1;
  // 1px less keeps the preview under the
  // cursor, which is required for successful drag

  const newTop = threadViewHeight - newHeight;

  // TODO: The absolute position is not working well under Helpdesk container
  return {
    cursor: 'ns-resize',
    position: 'absolute',
    top: newTop,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    width: '100%',
    background: 'rgba(100, 100, 100, 0.3)'
  };
};
class ReplyEditorResizePreview extends Component {
  render() {
    const {
      startOffset,
      currentOffset,
      item,
      maxEditorHeight,
      minEditorHeight
    } = this.props;
    if (!item || item.id !== RESIZABLE_REPLY_EDITOR_ID) {
      // we're not dragging yet
      return null;
    }
    return (
      /*#__PURE__*/
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ position: string; top: number; bottom: num... Remove this comment to see the full error message
      _jsx("div", {
        style: getDragLayerStyles(),
        children: /*#__PURE__*/_jsx("div", {
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ display: string; cursor?: undefined; posit... Remove this comment to see the full error message
          style: getPreviewWrapperStyles({
            startOffset,
            currentOffset,
            maxEditorHeight,
            minEditorHeight
          }),
          children: /*#__PURE__*/_jsx(ResizableDragHandle, {
            isPreview: true
          })
        }, "resizabled-editor-preview")
      })
    );
  }
}
ReplyEditorResizePreview.displayName = 'ReplyEditorResizePreview';
const collect = monitor => ({
  item: monitor.getItem(),
  currentOffset: monitor.getClientOffset(),
  startOffset: monitor.getInitialClientOffset()
});
export default DragLayer(collect)(ReplyEditorResizePreview);